<script>
  import { toSrcsetString } from '@nrk/dh-basis-mediainfo/render-utils'
  import Intersection from '../../../lib/intersection.svelte'

  export let images
</script>

<Intersection let:visible threshold={0}>
  <div
    class:visible
    class="grid"
    role="img"
    aria-label="Fire barnebilder i en kollage. Erez 12 år, Sahar 16år, Ela 8år og Dafna 15år"
  >
    {#each images as image}
      {@const srcsetJpg = image.mediaInfo.sources.find(
        (source) => source.type === 'image/jpeg',
      ).srcset}
      {@const srcsetwebp = image.mediaInfo.sources.find(
        (source) => source.type === 'image/webp',
      ).srcset}
      <picture class="wrapper">
        <source
          type="image/webp"
          srcset={toSrcsetString(srcsetwebp)}
          sizes="(max-width: 720px) 50vw, 300px"
        />
        <source
          type="image/jpeg"
          srcset={toSrcsetString(srcsetJpg)}
          sizes="(max-width: 720px) 50vw, 300px"
        />
        <img loading="lazy" sizes="(max-width: 720px) 50vw, 300px" alt="" />
        <span class="badge">{image.mediaInfo.title}</span>
      </picture>
    {/each}
  </div>
</Intersection>

<style>
  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    opacity: 0;
  }

  .visible {
    animation: fade-in ease-in-out 1000ms;
    opacity: 1;
    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  }

  img {
    border-radius: 5px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .wrapper {
    position: relative;
  }

  .badge {
    position: absolute;
    right: -6px;
    bottom: -6px;
    padding: 6px 10px;
    font-weight: var(--nrk-sans-weight-medium);
    font-size: calc(15 / 16 * 1rem);
    font-variation-settings: var(--nrk-sans-condensed);
    color: var(--dhsa-color-background-primary);
    background: var(--dhsa-color-accent-primary);
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
</style>
